import { Component, Input, OnInit } from "@angular/core";

import { AggregationGroupModel } from "../../../../models/aggregation-group.model";
import { SearchFilterMetadataModel } from "../../../../models/search-filter-metadata.model";

import { MarketplaceSearchForm } from "../../forms/marketplace-search.form";
import { SearchTabConfigModel } from "../../models/search-tab-config.model";

// declare function externalResetSearchFormFn(): any;

@Component({
    selector: "pcg-ng-marketplace-search-filters",
    template: require('./marketplace-search-filters.component.html')
})
export class MarketplaceSearchFiltersComponent implements OnInit {
    @Input()
    public searchConfig: SearchTabConfigModel;

    @Input()
    public searchForm: MarketplaceSearchForm;

    public categories: AggregationGroupModel;
    public areas: AggregationGroupModel;

    private static mapFilterToAggregation(filter: SearchFilterMetadataModel, value: Array<string> = []): AggregationGroupModel {
        const aggregation = {
            expanded: (filter.alias === "categories"),
            title: filter.caption,
            name: filter.alias,
            items: filter.attributes.map(attribute => {
                return {
                    selected: (value.indexOf(attribute.id) > -1),
                    expanded: false,
                    title: attribute.name,
                    value: attribute.id,
                    count: 0,
                    subcategories: attribute.nestedAttributes
                        ? attribute.nestedAttributes.map(nestedAttribute => {
                            return {
                                selected: (value.indexOf(nestedAttribute.id) > -1),
                                expanded: false,
                                title: nestedAttribute.name,
                                value: nestedAttribute.id,
                                count: 0,
                                subcategories: null
                            };
                        })
                        : null,
                };
            })
        } as AggregationGroupModel;

        aggregation.items.forEach(category => {
            category.expanded = (category.subcategories && category.subcategories.some(subcategory => subcategory.selected));
        });

        return aggregation;
    }

    public ngOnInit(): void {
        let filter: SearchFilterMetadataModel;

        filter = this.searchConfig.searchFilters.find(item => item.alias === "categories");
        if (filter) {
            this.categories = MarketplaceSearchFiltersComponent.mapFilterToAggregation(filter, this.searchForm.categories.value);
        }

        filter = this.searchConfig.searchFilters.find(item => item.alias === "areas");
        if (filter) {
            this.areas = MarketplaceSearchFiltersComponent.mapFilterToAggregation(filter, this.searchForm.areas.value);
        }
    }

    // public onResetButtonClicked(): void {
    //     externalResetSearchFormFn();
    //
    //     this.searchForm.reset();
    //     this.searchForm.submit();
    // }
}
